import { calcCurrentDuration, calcCurrentPrice } from '../../utils/packagesUtils';
import { VO_TYPE } from '../../utils/calculator';
import {
    SELECT_PACKAGE,
    UPDATE_CALCULATOR,
    UPDATE_CUSTOM_EXTRA,
    UPDATE_EXTRA_FAST,
    UPDATE_FEATURE,
    UPDATE_PRICE,
    UPDATE_QUANTITY,
    UPDATE_VO_DATA
} from '../../actions/packages';
import formatPackageList, { getNewPrice } from './utils';

const packagesReducer = ({packages, requestContext}) => {

    const initialState = {
        packageList: formatPackageList(packages, requestContext),
        selectedPackageId: 0,
        quantity: 1
    };

    return (state = initialState, action) => {
        switch (action.type) {
            case UPDATE_PRICE:
                return {
                    ...state,
                    packageList: state.packageList.map((packageData) => {
                        const newCurrentPrice = calcCurrentPrice(packageData, state.quantity);

                        return {
                            ...packageData,
                            currentPrice: getNewPrice(packageData, newCurrentPrice)
                        };
                    })
                };
            case UPDATE_CALCULATOR:
                return {
                    ...state,
                    packageList: state.packageList.map((packageData) => {
                        const { calculators } = packageData;
                        const { calculatorId, value } = action.data;

                        const newCalculators = calculators.map((calculator) => {
                            if (calculator.id === calculatorId) {
                                return { ...calculator, currentValue: value };
                            } else {
                                return calculator;
                            }
                        });
                        const newPackageData = {...packageData, calculators: newCalculators};

                        return {
                            ...newPackageData
                        };
                    })
                };
            case UPDATE_VO_DATA:
                const { voData } = action.data;
                let newCurrentPrice;

                return {
                    ...state,
                    packageList: state.packageList.map((packageData) => {
                        const { calculators, extraFast } = packageData,
                            newCalculators = calculators.map((calculator) => {
                                if (calculator.id === voData.calculatorId) {
                                    newCurrentPrice = voData.price;
                                    return {...calculator, type: VO_TYPE, currentPrice: voData.price};
                                } else {
                                    return calculator;
                                }
                            });

                        const newFeatures = packageData.features.map((feature) => {
                            const voDataFeature = voData.purchaseExtras[feature.id];

                            return {...feature, ...voDataFeature};
                        });

                        const newPackageData = {
                            ...packageData,
                            features: newFeatures,
                            calculators: newCalculators,
                            currentDuration: voData.duration
                        };

                        if (extraFast) {
                            const voDataExtraFast = voData.purchaseExtras[extraFast.id];
                            newPackageData.extraFast = {...extraFast, ...voDataExtraFast};
                        }

                        const currentPrice = getNewPrice(packageData, newCurrentPrice);

                        return {
                            ...newPackageData,
                            currentPrice
                        };
                    })
                };
            case UPDATE_EXTRA_FAST:
                return {
                    ...state,
                    packageList: state.packageList.map((packageData) => {
                        if (packageData.id !== action.data.packageId) {
                            return packageData;
                        }

                        const {extraFast} = packageData,
                            newExtraFast = {...extraFast, currentValue: action.data.value},
                            newPackageData = {...packageData, extraFast: newExtraFast};

                        return {
                            ...newPackageData,
                            currentPrice: calcCurrentPrice(newPackageData, state.quantity),
                            currentDuration: calcCurrentDuration(newPackageData)
                        };
                    })
                };
            case SELECT_PACKAGE:
                return {
                    ...state,
                    selectedPackageId: action.data.packageId
                };
            case UPDATE_FEATURE:
                return {
                    ...state,
                    packageList: state.packageList.map((packageData) => {
                        const {features} = packageData;

                        const newFeatures = features.map((feature) => {
                            if (feature.id !== action.data.featureId) {
                                return feature;
                            } else {
                                const amount = action.data.amount;
                                const currentDuration = amount > 0 ? feature.duration * amount : feature.duration;
                                return {...feature, amount, currentDuration};
                            }
                        });
                        const newPackageData = {...packageData, features: newFeatures};

                        return {
                            ...newPackageData,
                            currentPrice: calcCurrentPrice(newPackageData, state.quantity),
                            currentDuration: calcCurrentDuration(newPackageData)
                        };
                    })
                };
            case UPDATE_CUSTOM_EXTRA:
                return {
                    ...state,
                    packageList: state.packageList.map((packageData) => {
                        const {customExtras} = packageData;

                        const newCustomExtras = customExtras.map((customExtra) => {
                            if (customExtra.id !== action.data.customExtraId) {
                                return customExtra;
                            } else {
                                return {...customExtra, amount: action.data.amount};
                            }
                        });
                        const newPackageData = {...packageData, customExtras: newCustomExtras};

                        return {
                            ...newPackageData,
                            currentPrice: calcCurrentPrice(newPackageData, state.quantity),
                            currentDuration: calcCurrentDuration(newPackageData)
                        };
                    })
                };
            case UPDATE_QUANTITY:
                return {
                    ...state,
                    packageList: state.packageList.map((packageData) => ({
                        ...packageData,
                        currentPrice: calcCurrentPrice(packageData, action.data.quantity)
                    })),
                    quantity: action.data.quantity
                };
            default:
                return state;
        }
    };
};

// Selectors

export const getPackageById = ({ packageList }, packageId) => packageList.find(({ id }) => (id === packageId));

export const isTriplePackage = ({ packageList }) => packageList.length === 3;

export const isSinglePackage = ({ packageList }) => packageList.length === 1;

export const getSingleCalculator = (state, packageId) => {
    const { calculators } = getPackageById(state, packageId);

    return calculators && calculators.length ? calculators[0] : null;
};

// End of selectors

export default packagesReducer;
